export const useStringShorting = (s, l, useShorting) => {
    const hasOverflow = s.length > l;

    let resString = s;
    if (useShorting && hasOverflow) {
        resString = s.substring(0, l - 3) + "...";
    }

    return [resString, hasOverflow];
}